import { Component, OnInit } from '@angular/core'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import { MatSelectChange } from '@angular/material/select'
import { ActivatedRoute, Router } from '@angular/router'
import { UnespCoreMessageService } from '@unesp/core'
import { DepartamentoAnalisarInscricao } from 'src/app/models/departamento-analisar-inscricao'
import { DepartamentoAnalisarInscricaoForm } from 'src/app/models/departamento-analisar-inscricao-form'
import { DepartamentoService } from 'src/app/services/departamento-service'

@Component({
  selector: 'app-departamento-analisar-inscricao',
  templateUrl: './departamento-analisar-inscricao.component.html',
  styleUrls: ['./departamento-analisar-inscricao.component.css'],
  standalone: false
})
export class DepartamentoAnalisarInscricaoComponent implements OnInit {
  id: number = 0
  inscricao?: DepartamentoAnalisarInscricao

  form = new FormGroup({
    semestre1: new FormControl('', Validators.required),
    semestre2: new FormControl('', Validators.required),
    aprovado: new FormControl('', Validators.required),
    motivo: new FormControl(''),
  })

  constructor(
    private route: ActivatedRoute,
    private departamentoService: DepartamentoService,
    private unespCoreMessageService: UnespCoreMessageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['id']
      this.departamentoService.analisarInscricao(this.id).subscribe(data => {
        this.inscricao = data
        this.form.controls['motivo'].setValue(data.motivo)
        if (data.aprovado === 'sim' || data.aprovado === 'rep' || data.aprovado === 'can') {
          this.form.controls['aprovado'].setValue(data.aprovado)
        }
        if (data.semestre1 === 0 || data.semestre1 === 1) {
          this.form.controls['semestre1'].setValue(data.semestre1.toString())
        }
        if (data.semestre2 === 0 || data.semestre2 === 1) {
          this.form.controls['semestre2'].setValue(data.semestre2.toString())
        }
        // Situação antiga, quando o semestre ainda não havia sido selecionado pelo departamento e discente
        if (!this.inscricao.semestreJaDefinido) {
          if (!this.inscricao.oferta1Semestre) {
            this.form.get('semestre1')?.setValue('0')
          }
          if (!this.inscricao.oferta2Semestre) {
            this.form.get('semestre2')?.setValue('0')
          }
        }
        if (data.aprovado !== 'nao') {
          this.form.controls['aprovado'].setValue(data.aprovado)
        }
      })
    })
  }

  applyTouchedToInvalidFields() {
    for (const name in this.form.controls) {
      if (this.form.get(name)?.invalid) {
        this.form.get(name)?.markAsTouched()
      }
    }
  }

  gravar(): void {
    this.applyTouchedToInvalidFields()
    if (!this.form.valid) {
      this.unespCoreMessageService.showMessageError('Erro ao preencher os dados do formulário')
      return
    }
    let formulario = <DepartamentoAnalisarInscricaoForm>this.form.value
    if (formulario.aprovado === 'sim') {
      formulario.motivo = ''
    }
    if (formulario.semestre1 === '0' && formulario.semestre2 === '0') {
      this.unespCoreMessageService.showMessageError('Você deve selecionar o semestre')
    } else if (formulario.semestre1 === '1' && formulario.semestre2 === '1') {
      this.unespCoreMessageService.showMessageError('Você deve selecionar apenas um semestre')
    } else {
      this.departamentoService.registrarAnaliseInscricao(this.id, formulario).subscribe(data => {
        if (data.status === 'ok') {
          this.unespCoreMessageService.showMessageSuccess(`Inscrição #${this.id} registrada com sucesso`)
          this.router.navigate(['/departamento/aprovar-inscricao'])
        } else {
          this.unespCoreMessageService.showMessageError(data.message)
        }
      })
    }
  }

  alteraSituacao(selection: MatSelectChange): void {
    if (selection.value === 'rep' || selection.value === 'can') {
      this.form.get('motivo')?.setValidators([Validators.required])
    } else {
      this.form.get('motivo')?.clearValidators()
    }
    this.form.get('motivo')?.updateValueAndValidity()
  }
}
